import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Rubik";
        src: url("/fonts/Rubik-Regular.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Rubik-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Rubik', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #48bfe3;
        color:#333333 !important ;
        overflow-x: hidden;
    }

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        border-radius: 4px;
        border: none;
        background: transparent;
        /* transition: all 0.3s ease-in-out;   */
        outline: rgba(255, 255, 255, 0.25) solid 0.5rem;
        width: 100%;  
        padding: 0.5rem !important;
        margin-top: 5px;

        :focus-within {
            background: none;
            border: 2px solid #2e186a;
            outline: transparent solid 0.5rem;
           
        }
    }

    .marquee {
			border: 2px solid transparent ;
			display: flex ;
			overflow: hidden ;
			white-space: nowrap ;
			width: 300px ;
            align-items: center;
            justify-content: center;
		}
		.marquee__item {
			animation-duration: 4s ;
			animation-iteration-count: infinite ;
			animation-name: marquee-content ;
			animation-timing-function: linear ;
			padding: 5px 15px 5px 15px ;
		}
		.marquee:hover .marquee__item {
			animation-play-state: paused ;
		}
        @keyframes marquee-content {
        from {
            transform: translateX( 0% );
        }
        to {
            transform: translateX( -100% );
        }
}
    .marquee-content {
            font-size: 30px;
        }

    @keyframes fadeInFlash {
        0% {
            opacity: 0;
            filter: brightness(1) blur(3px);
            transform: translateY(15px);
        }
        50% {
            opacity: 0.8;
            filter: brightness(1.5) blur(0);
            transform: translateY(100px);
        }
        80% {
            opacity: 1;
            filter: brightness(1) blur(0.5px);
            transform: translateY(0);
        }
        100% {
            opacity: 1;
            filter: brightness(1) blur(0);
            transform: translateY(0);
        }
        }

    .link-color {
        color:#00a56a;
        text-decoration: underline;
        }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #333333;
        font-size: 52px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }
    .magic-bg {
        background-image: radial-gradient(circle at center center, rgba(36,0,0, 0),rgb(40,159,237)),repeating-linear-gradient(135deg, rgb(40,159,237) 0px, rgb(40,159,237) 1px,transparent 1px, transparent 4px),repeating-linear-gradient(45deg, rgb(201,192,78) 0px, rgb(201,192,78) 5px,transparent 5px, transparent 6px),linear-gradient(90deg, rgb(40,159,237),rgb(40,159,237));
        border-radius: 12px;
        padding: 40px 40px 20px 40px;

        @media only screen and (max-width: 890px) {
            padding: 15px 15px 1px 15px;
        }
      
        @media only screen and (max-width: 414px) {
            padding: 15px 15px 1px 15px;
        }
        }
    .cena-title {
        margin: 0;
        font-size: 28px;
        font-weight: 600;
        font-family: Rubik !important;

        @media only screen and (max-width: 890px) {
            font-size: 26px;
        }
      
        @media only screen and (max-width: 414px) {
            font-size: 24px;
        }
    }
    .card-title {
    text-align: center;
    margin-bottom: 80px;
    font-size: 36px;
    font-weight: bold;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 2px;

    @media only screen and (max-width: 890px) {
        font-size: 32px;
        }
      
        @media only screen and (max-width: 414px) {
            font-size: 28px;
        }
    }

    .card-style {
        background: white;
        padding: 15px;
        border-radius: 15px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        margin-bottom: 30px;
        width: 100%;
        max-width: 90%;
        text-align: center;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        position: relative;
        outline: rgba(255, 255, 255, 0.25) solid 0.5rem;

        @media only screen and (max-width: 890px) {
            max-width: 100%;
        }
      
        @media only screen and (max-width: 414px) {
            max-width: 100%;
        }
        }

        .card-name {
        font-weight: bold;
        margin-top: 15px;
        font-size: 22px;
        color: #333;

        @media only screen and (max-width: 890px) {
            font-size: 20px;
        }
      
        @media only screen and (max-width: 414px) {
            font-size: 18px;
            margin-bottom: 0;
        }
        }
        .card-p {
        font-style: italic;
        font-size: 18px;
        color: #555;

        @media only screen and (max-width: 890px) {
            font-size: 16px;
        }
      
        @media only screen and (max-width: 414px) {
            font-size: 14px;
        }
        }


    .video-div {
        width: 100%;
        height: 76vh;
        object-fit: contain;
        display: block;
        z-index: 1;
        position: relative;

        @media only screen and (max-width: 890px) {
          height: unset;
        }
      
        @media only screen and (max-width: 414px) {
            height: unset;
        }
    }
    .p-cena {
        margin-bottom: 0;
        font-size: 26px;
        font-weight: 700;
        padding: 6px 12px;
        border-radius: 8px;
        display: inline-block;
        box-shadow:rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px ;
        
        @media only screen and (max-width: 414px) {
          font-size: 16px;
          margin-top: 5px;
        }
    }
    .main-logo {
        margin-bottom: -19px;
        margin-top: -16px;
        height: 90px;

        @media only screen and (max-width: 414px) {
        margin-bottom: -15px;
        margin-top: -14px;
        height: 80px;
        }
    }
    .main-logo-open-nav {
        margin-bottom: -19px;
        margin-top: -20px;
        height: 90px;

        @media only screen and (max-width: 414px) {
        margin-bottom: -15px;
        margin-top: -20px;
        height: 80px;
        margin-left: 7px !important;
        }
    }
    .main-title {
        font-size: 70px;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
          width: 100% !important;
          margin-top: 80px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 45px;
          width: 100% !important;
          margin-top: 60px;
        }
    }
    .ant-r {
        display: flex !important;
    flex-wrap: wrap !important;
    gap: 0 10px !important;
    }
    .downloadbtn {
        padding: 7px 15px;
        font-size: 20px;
        font-weight: bold;
        color: #101010;
        background-color: #f5f5f5;
        border-radius: 6px;
        border: 4px solid #101010;
        box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
        cursor: pointer;
        transition:transform 0.2s ease-in-out;
    }
    .citat-div > p {
    word-break: break-word;         
    }
    .cena-div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding-right: 10%;
}

    .downloadbtn:hover {
        opacity: 0.8;
    }
        .slick-dots {
        position:absolute;
        bottom :30px !important;
        }
        @keyframes scrollText {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(-100%);
        }
        }

    .slick-prev:before, .slick-next:before {
    color:#01cbe1 !important;
    }
    .slick-next {
    right:15px !important;
    }
    .slick-prev {
    left:15px !important;
    z-index:1 !important;
    }
    .svg-2 {
        margin-bottom: -365px;
    margin-left: 113px;
    width: 400px !important;
    }
    .shape {
    margin-bottom: -365px;
    margin-left: 113px;
    width: 400px !important;
    }
    p {
        color: #101010;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color:rgb(117, 117, 118);

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }
    .ant-notification-notice {
        background-color:rgb(255, 155, 163) !important;
        color: #99000d !important;
        border: 2px solid #99000d !important;
        padding: 15px !important;
    }
    .anticon svg,
    .ant-notification-notice-with-icon .ant-notification-notice-message,
    .ant-notification-notice-with-icon .ant-notification-notice-description {
        color:#99000d !important;
        font-weight: 600 !important;
    }
    .ant-drawer-content {
        backdrop-filter: blur(20px) !important;
        background-color: rgba(255 255 255 / 50%) !important;
    }
    .anticon svg {
    cursor:pointer;}
        .ant-drawer-content-wrapper {
            width: 100% !important;
        }
        .phone-icon {
            width: 24px;
            margin-right: 10px;
        }
        .email-icon {
            width: 25px;
            margin-right: 10px;
        }
        .slick-slide {
      margin: 0 15px;
  }
  .slick-prev::before, .slick-next::before
 {
    color: rgba(255, 255, 255, 1) !important;
}
.wavy-divider {
  width: 100%;
  overflow: hidden;
  line-height: 0;
}

.wavy-divider svg {
  display: block;
  width: 100%;
  height: 80px; 
}

  /* the parent */
  .slick-list {
      margin: 0 -27px;
      margin-top: 50px !important;
      height: 300px !important;
  }
  
        .magic-want {
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            margin-top: -151px;
            margin-left: -220px;
            margin-bottom: 100px;
        }
         .reshot-icon img,.magic-want img {
            width: 50px;
            height: 50px;
        }
        .reshot-icon {
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            margin-top: -352px;
            margin-left: -790px;
            margin-bottom: 266px;
        }
        .cena-btn {
            position: absolute;
            top: 17px;
            right: 10px;
            padding: 5px 10px;
            color: #f5f5f5;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            width: 35px;
            height: 35px;
            font-size: 20px;
            line-height: 22px;
            font-weight: bold;
            z-index: 2;
            box-shadow:
                rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
                rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
        }
        @media (max-width: 768px) {
        .hide-on-mobile {
            display: none !important;
        }
        .cena-btn {
            top: 10px !important;
        }
        .slick-slide {
      margin:unset !important;
  }

  /* the parent */
  .slick-list {
    margin:unset !important;
  }
        .svg-2 {
        margin-bottom: -204px;
        margin-left: -89px;
        width: 294px !important;
        }
        .phone-icon {
            width: 17px;
            margin-right: 10px;
        }
        .email-icon {
            width: 19px !important;
            font-weight: normal !important;
            margin-right: 10px;
        }
        .reshot-icon {
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            margin-top: -747px !important;
            margin-left: 230px !important;
            margin-bottom: 665px !important;
        }
    
        .cena-div {
            display: flex;
            -webkit-box-align: center;
            align-items: flex-start !important;
            -webkit-box-pack: justify;
            justify-content: space-between;
            width: 100%;
            padding-right: 0 !important;
            flex-direction: column !important;
}
        .shape {
        margin-bottom: -294px;
        margin-left: -38px;
        width: 294px !important;
    }
}
.ant-notification-notice-success .ant-notification-notice-description {
  color: #52c41a !important;
}

.ant-notification-notice-message {
  color: #52c41a !important;
}

.ant-notification-notice-success {
  border-left-color: #52c41a !important;
}
.ant-notification-notice {
    border-color: #52c41aff !important;
    background-color: #e8ffdd !important;
}
    .anticon svg, .ant-notification-notice-with-icon .ant-notification-notice-message, .ant-notification-notice-with-icon .ant-notification-notice-description {
    color: #52c41a !important;
    font-weight: 600 !important;
}  
.anticon.ant-notification-notice-icon-success {
    color: #52c41a !important;
}  
.anticon svg {
    color: unset !important;
}
`;
